import React from 'react';
import { SoundLogoOverlay } from '../SoundLogoOverlay';

export const ExploreCard = ({
  label,
  backgroundColor,
  onClick,
}: {
  label: string;
  backgroundColor: string;
  onClick: () => void;
}) => {
  return (
    <div
      className="duration-6000 relative h-[116px] cursor-pointer overflow-hidden rounded-lg bg-black transition-all ease-in-out hover:brightness-[116%] md:h-[165px] md:w-full"
      style={{ backgroundColor: backgroundColor }}
      onClick={onClick}
    >
      <p className="relative z-above1 px-4 py-3 font-title text-title-m font-medium text-white md:text-title-m">
        {label}
      </p>
      <div className="absolute top-0 overflow-hidden">
        <SoundLogoOverlay className="relative h-[165px] rounded-lg" />
        <div className="z-0 absolute top-0 h-[100px] w-[178px] rounded-lg" />
      </div>
    </div>
  );
};
